import React from 'react';
import { NavLink } from 'react-router-dom';
import Header from '../Header';

const SuperuserLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navItems = [
    { label: 'Dashboard', to: '/superuser' },
    { label: 'Organizations', to: '/superuser/organizations' },
    { label: 'Onboarding', to: '/superuser/onboarding' },
    { label: 'Reports', to: '/superuser/reports' },
    { label: 'Prime Reports', to: '/superuser/prime-reports' },
    { label: 'Assets', to: '/superuser/assets' },
    { label: 'Indications', to: '/superuser/indications' },
    { label: 'TT suggestions', to: '/superuser/trial-tracker-suggestions' },
    { label: 'Ongoing Trials', to: '/superuser/ongoing-trials' },
    { label: 'Landscapes', to: '/superuser/landscapes' },
    { label: 'Catalyst Calendars', to: '/superuser/calendars' },
    { label: 'Readout companies', to: '/superuser/readout-companies' },
    { label: 'Activity', to: '/superuser/activity' },
    { label: 'Engagement', to: '/superuser/engagement' },
  ];

  return (
    <div className="min-h-screen text-slate-900 pb-20 relative bg-slate-50 font-sans">
      <Header />
      <div className="w-full max-w-[100%] mx-auto px-3 sm:px-4 lg:px-6 py-8 grid grid-cols-1 lg:grid-cols-[260px,1fr] gap-6">
        <aside className="bg-white rounded-2xl shadow-card border border-gray-100 p-4 h-fit">
          <h2 className="text-xs font-semibold uppercase tracking-wide text-slate-400 px-2 mb-3">Superuser</h2>
          <nav className="space-y-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `block px-3 py-2 rounded-xl text-sm font-semibold transition-colors ${
                    isActive
                      ? 'bg-indigo-50 text-indigo-700'
                      : 'text-slate-600 hover:text-indigo-700 hover:bg-slate-50'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </aside>
        <section className="min-w-0">{children}</section>
      </div>
    </div>
  );
};

export default SuperuserLayout;
